import qsa from 'dom-helpers/querySelectorAll';
import getWidth from 'dom-helpers/width';
import { ResizeObserver } from 'resize-observer';

export const resizeFBIframe = $iframe => {
  let $src = $iframe.getAttribute('src') || $iframe.getAttribute('data-src');
  if (!$src) {
    return;
  }

  const width = getWidth($iframe);
  let $newSrc = $src.replace(/width=.\d+/, `width=${width}`);
  $iframe.setAttribute('src', $newSrc);
};

export default doc => {
  try {
    const $els = qsa(doc, '.fb-page-iframe');
    if ($els.length > 0) {
      const ioResize = new ResizeObserver((entries, observer) => {
        entries.forEach(entry => {
          resizeFBIframe(entry.target);
        });
      });

      const io = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            ioResize.observe(entry.target);
          } else {
            ioResize.unobserve(entry.target);
          }
        });
      });

      $els.forEach($el => {
        io.observe($el);
      });
    }
  } catch (e) {
    console.warn(e);
  }
};
